<div class="grid w-full rounded-lg border border-solid bg-white">
  <span class="mb-2 ml-4 mt-4 h-[30px] text-sm text-aux-gray-dark-100">{{ card?.title }}</span>

  <span class="mb-1 ml-4 text-2xl font-bold text-aux-gray-darkest">{{ card?.value }}</span>

  <span class="mb-4 ml-4 text-xs text-aux-black">Trial Forecast</span>
</div>
